import React from 'react'
import { Button, CircularProgress, makeStyles, Typography } from '@material-ui/core'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import RefreshIcon from '@material-ui/icons/Refresh'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import { useSnackbar } from '../../shared/hooks'
import { useSennaBatchReport } from '../../contexts/SennaBatchReportContext'
import styles from './SennaBatchReportNotification.styles'

const useStyles = makeStyles(styles)

const SennaBatchReportNotification = () => {
  const classes = useStyles()
  const { snackbarError } = useSnackbar()

  const {
    latestGeneration,
    isLoadingLatest,
    isRetrying,
    isDownloading,
    retryLatest,
    downloadLatest,
  } = useSennaBatchReport()

  if (isLoadingLatest || !latestGeneration || latestGeneration.status === 'DELETED') {
    return null
  }

  const handleRetry = async () => {
    try {
      await retryLatest()
    } catch (error) {
      snackbarError('Não foi possível repetir a geração das devolutivas')
    }
  }

  const handleDownload = async () => {
    try {
      await downloadLatest()
    } catch (error) {
      snackbarError('Não foi possível baixar as devolutivas')
    }
  }

  if (latestGeneration.status === 'PROCESSING') {
    return (
      <div className={`${classes.root} ${classes.processing}`} role="status">
        <div className={classes.content}>
          <CircularProgress size={20} thickness={4} color="inherit" />

          <Typography variant="body2" className={classes.label}>
            Gerando devolutivas...
          </Typography>
        </div>
      </div>
    )
  }

  if (latestGeneration.status === 'ERROR') {
    return (
      <div className={`${classes.root} ${classes.error}`} role="alert">
        <div className={classes.content}>
          <ErrorOutlineIcon />

          <Typography variant="body2" className={classes.label}>
            Erro ao gerar devolutivas
          </Typography>
        </div>

        <Button
          size="small"
          className={`${classes.actionButton} ${classes.retryButton}`}
          startIcon={<RefreshIcon />}
          disabled={isRetrying}
          onClick={handleRetry}
        >
          {isRetrying ? 'Repetindo...' : 'Repetir'}
        </Button>
      </div>
    )
  }

  if (latestGeneration.status === 'FINISHED') {
    return (
      <div className={`${classes.root} ${classes.finished}`} role="status">
        <div className={classes.content}>
          <CheckCircleOutlineIcon />

          <Typography variant="body2" className={classes.label}>
            Devolutivas prontas
          </Typography>
        </div>

        <Button
          size="small"
          variant="contained"
          className={`${classes.actionButton} ${classes.downloadButton}`}
          startIcon={<CloudDownloadIcon />}
          disabled={isDownloading}
          onClick={handleDownload}
        >
          {isDownloading ? 'Baixando...' : 'Baixar ZIP'}
        </Button>
      </div>
    )
  }

  return null
}

export default SennaBatchReportNotification
